import axios from "axios"

let isRefreshing = false
let refreshSubscribers = []

const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb)
}

const onRefreshed = (token) => {
  refreshSubscribers.forEach(cb => cb(token))
  refreshSubscribers = []
}


// Create an Axios instance
const dev = process.env.REACT_APP_DEV
let axiosInstance
if (dev) {
  axiosInstance = axios.create({
    baseURL: "http://localhost:9000/api",
    withCredentials: true
  })
} else {
  axiosInstance = axios.create({
    baseURL: '/api',
    withCredentials: true
  })
}


// Add a request interceptor to attach token automatically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken") // Get token from storage
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (
      error.response?.status === 403 &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise(resolve => {
          subscribeTokenRefresh((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`
            resolve(axiosInstance(originalRequest))
          })
        })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const { data } = await axios.post(
          '/refresh',
          {},
          { withCredentials: true }
        )

        localStorage.setItem("accessToken", data.accessToken)
        isRefreshing = false
        onRefreshed(data.accessToken)

        originalRequest.headers.Authorization = `Bearer ${data.accessToken}`
        return axiosInstance(originalRequest)
      } catch (err) {
        isRefreshing = false
        refreshSubscribers = []
        localStorage.removeItem("accessToken")
        return Promise.reject(err)
      }
    }

    return Promise.reject(error)
  }
)


export default axiosInstance
